import HeadBrick from "../HeadBrick/HeadBrick";
import Style from './EndPanel.module.less'
import FJLocalStore from "../../store/FJLocalStore";
import successIcon from '../../icon/success.svg'
import InlineSVG from "react-inlinesvg";
import {useDispatch, useSelector} from "react-redux";
import mainAction from "../../reducer/action/mainAction";
import {useEffect} from "react";

let EndPanel = (props) => {
    let {isAnnually} = props
    let dispatch = useDispatch()
    let {method, dataInfo, currentPlan, selectPage, teamSubscription} = useSelector(state => {
        return {
            method: state.mainReducer.method,
            dataInfo: state.mainReducer.dataInfo,
            currentPlan: state.mainReducer.currentPlan,
            selectPage: state.mainReducer.selectPage,
            teamSubscription: state.mainReducer.teamSubscription
        }
    })
    let _close = () => {
        dispatch(mainAction.closeSubscribeView())
    }
    let _handleClickStart = () => {
        if (method === 'popup') {
            dispatch(mainAction.closeSubscribeView())
        } else {
            window.location.href = FJLocalStore.getJumpUrl('/editor/')
        }


        // window.FJGlobalariable.modSubscription.getStartCallback();
    }
    let timestampToDate = (timestamp) => {
        let map = [
            'Jan',
            'Feb',
            'Mar',
            'Apr',
            'May',
            'Jun',
            'Jul',
            'Aug',
            'Sep',
            'Oct',
            'Nov',
            'Dec',
        ];
        let date = new Date(timestamp * 1000);
        let day = date.getDate();
        let month = date.getMonth();
        let year = date.getFullYear();
        return map[month] + ' ' + day + ', ' + year;
    }

    let price = () => {
        return dataInfo.amount / 100;
    }
    let endDate = () => {
        return selectPage === 'team' ? timestampToDate(teamSubscription.period_end) : timestampToDate(currentPlan.period_end);
    }
    let _descText = () => {
        let text = FJLocalStore._('SUCCESSFUL_DESC')
        text = text.replace('%s', price())
        text = text.replace('%s', endDate())
        return text
    }
    let showImage = () => {
        let amount = dataInfo.amount / 100;
        return (amount > 0);
    }
    let affiliateURL = () => {
        let coupon = dataInfo.coupon;
        let discount = dataInfo.discount;
        let amount = dataInfo.amount / 100;
        let transactionID = dataInfo.transaction_id;

        if (!transactionID)
            transactionID = window.fjuser.info.id;
        let url = null;

        if (amount > 0) {
            if ((document.domain === "www.designcap.com") || (document.domain === "designcap.com")) {
                url = "https://shareasale.com/sale.cfm?amount=" + amount + "&tracking=" + transactionID + "&transtype=sale&merchantID=79751&storeid=3";
                if (coupon && coupon !== '') {
                    url += "&couponcode=" + coupon;
                }
            } else if ((document.domain === "www.flexclip.com") || (document.domain === "flexclip.com")) {
                url = "https://shareasale.com/sale.cfm?amount=" + amount + "&tracking=" + transactionID + "&transtype=sale&merchantID=79751&storeid=1";
                if (coupon && coupon !== '') {
                    url += "&couponcode=" + coupon;
                }

                try {
                    let packageName = selectPage
                    let period = isAnnually ? 'annual' : 'monthly';
                    gtag('event', 'purchase', {
                        "transaction_id": transactionID,
                        "affiliation": "",
                        "value": amount,
                        "currency": "USD",
                        "tax": 0,
                        "shipping": 0,
                        "items": [
                            {
                                "id": packageName,
                                "name": packageName,
                                "list_name": packageName,
                                "brand": "FlexClip",
                                "category": period,
                                "variant": period,
                                "list_position": 1,
                                "quantity": 1,
                                "price": amount
                            }
                        ]
                    });
                } catch (e) {
                }
            }

            if (window.affiliateStatistics) {
                window.affiliateStatistics({transactionID, amount, coupon, discount});
                window.affiliateStatistics = null;
            }
        }

        return url;
    }

	/**
	 * 增加订阅成功统计事件
	 */
	useEffect(() => {
		if (window.eventLog) {
			window.eventLog.addEvent("revenue", {
				price: window.FJGlobalariable.modSubscription.state.amount / 100,
				plan: `${window.FJGlobalariable.modSubscription.state.selectPlan.package}_${window.FJGlobalariable.modSubscription.state.isAnnual ? 'annual' : 'monthly'}`,
				new_renew: window.FJGlobalariable.modSubscription.state.selectPlan.isPopular ? 'renew' : 'new',
				platform: window.fj.currentPlan.sub_type,
				coupon: window.FJGlobalariable.modSubscription.state.coupon
			})
		}
	}, [])

    return (
        <div className={Style.success_box}>
            <HeadBrick
                classname={Style.head}
                style={method === 'popup' ? {} : {display: 'none'}}
                closeClick={_close}
            />
            <div className={Style.successful_content}>
                <div>
                    <div className={Style.icon_box}>
                        <InlineSVG src={successIcon}/>
                    </div>
                    <h1 className={Style.title}>{FJLocalStore._('SUCCESSFUL_TITLE')}</h1>
                    {/*<p>{window.text_printf('SUB.SUCCESSFUL_DESC','$' + this.price, this.endDate)}</p>*/}
                    <p className={Style.desc}>{_descText()}</p>
                    <p
                        className={Style.target}
                        dangerouslySetInnerHTML={{
                            __html: FJLocalStore._('SUCCESS_VIEW_FEEDBACK')
                        }}
                    />
                    <div className={Style.btn} onClick={_handleClickStart}>{FJLocalStore._('BUTTON_GET_START')}</div>
                    {showImage() && <img src={affiliateURL()} width="1" height="1" alt=''/>}
                </div>
            </div>

        </div>
    )
}
export default EndPanel